/**
 * Layout menu item component
 */
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {InterpolateService} from '@ispm/shared/services/interpolate.service';
import {RouterManagerService} from '@ispm/core/services/router-manager.service';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {IdynamicFormItem} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {get} from 'lodash';
import {MenuItemService} from '@ispm/widgets/components/layout-engine-menu/layout-engine-menu-item/services/menu-item.service';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'ispm-layout-engine-menu-item',
  templateUrl: './layout-engine-menu-item.component.html',
  styleUrls: ['./layout-engine-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MenuItemService]
})
@Widget('MenuItem')
export class LayoutEngineMenuItemComponent implements OnInit, IWidgetItem {
  widgetUpdateValueCallback: (value) => void;
  @Input() config;

  constructor(private interpolateService: InterpolateService,
              private routerManagerService: RouterManagerService,
              private menuItemService: MenuItemService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  @Input() params;
  @Input() showCount: boolean;
  countValue$: Observable<number>;
  /**
   * set layout menu widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.config = _itemConfig.widgetPayload;
    this.conditionalShowCount();
  }

  /**
   *  Getting the show count config based on that count will be displayed
   */
  conditionalShowCount() {
    this.showCount = get(this.config, 'showCount', false);
    if (this.showCount) {
      this.countValue$ = this.menuItemService
        .getShowCountValue(get(this.config, 'dataBinding', [{ }]));
    }
  }
  /**
   * set layout menu widget config
   * @param widgetData
   */
  set widgetData(widgetData: any) {

  }

  ngOnInit() {
    if (!this.params) {
      this.params = {...this.activatedRoute.snapshot.queryParams, ...this.routerManagerService.parameters};
    }
  }

  redirectTo() {
    this.goToState(this.config.routeLink, this.params);
  }

  goToState(redirectUrl, param = { }) {
    const interpolatedParamsFromUrl = this.interpolateService.interpolate(redirectUrl, param);
    const redirectUrlState = this.routerManagerService.urlToState(interpolatedParamsFromUrl);
    this.router.navigate([redirectUrlState.name]);
  }
}
